import axios from 'axios';

const $ = document.getElementById.bind(document);

const formMessage: HTMLElement = $('js-form-message');
const submitButton: HTMLButtonElement = $('js-submit-button');

bindEvent($('js-contact-form'), 'submit', (event: Event) => {
  event.preventDefault();
  const submission: { [key: string]: string } = {};
  for (const elem of (<HTMLFormElement>event.target).elements) {
    const el: HTMLInputElement = <HTMLInputElement>elem;
    if (el.name) {
      submission[el.name] = el.value;
    }
  }

  formMessage.style.display = 'none';
  formMessage.classList.remove('form-error');
  formMessage.classList.remove('form-success');
  submitButton.disabled = true;
  const buttonText = submitButton.innerHTML;
  submitButton.innerHTML = 'Sending...';
  axios
    .post('/api/contact', submission)
    .then(({ data: { message } }) => {
      formMessage.innerHTML = message;
      formMessage.classList.add('form-success');
    })
    .catch(
      ({
        response: {
          data: { message },
        },
      }) => {
        formMessage.innerHTML = message;
        formMessage.classList.add('form-error');
      },
    )
    .then(() => {
      submitButton.disabled = false;
      formMessage.style.display = 'block';
      submitButton.innerHTML = buttonText;
    });
});

bindEvent($('js-switch-theme'), 'click', () =>
  (<any>window).switchThemes((<any>window).MLBtheme === 'alt' ? 'default' : 'alt'),
);

function bindEvent<K extends keyof HTMLElementEventMap>(element: HTMLElement, event: K, fn: (event: Event) => void) {
  if (element) {
    element.addEventListener(event, fn);
  }
}
